module.exports = __webpack_public_path__ + "img/3_3.71b1e764.png";